import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { STATIC_PATH } from "../../constants/config";
import { Modal } from "../../common-components/modal";
import { Icon } from "../header/header-components";
import Typography from "../../common-components/Typography";
import { font } from "../../constants/font";
import Action from "../../common-components/Action";
import { HeadingWrap } from "./payment-component";


const PaymentSuccess = ({ message }) => {
    const onSave = useCallback(() => {
        window.location.reload();
    }, []);

    return (
        <Modal
            padding="25px 25px 25px 25px"
            height="296px"
            width="512px"
            background={"#fff"}
            borderRadius="24px"
            showModal={true}
            preventClose={true}
        >
            <HeadingWrap className="paymentSuccess">
                <Icon
                    width="80px"
                    height="80px"
                    src={`${STATIC_PATH}payment-success-tick.png`}
                    alt="tick"
                    className="paymentIcon"
                />
                <Typography
                    content="Payment Successful!"
                    font={font.bold_20_16}
                    padding="3px 0"
                    align="center"
                    color="#313345"
                />
                <Typography
                    content={message}
                    font={font.normal_21}
                    // padding="3px 0"
                    color="#31304A"
                    enableTrim={false}
                    align="center"
                    margin="10px 0px 0"
                />
                <Action
                    borderRadius="8px"
                    text="Done"
                    marginTop="24px"
                    background="#00BAFF 0% 0% no-repeat padding-box"
                    width="216px"
                    height={"36px"}
                    onClick={onSave}
                />
            </HeadingWrap>
        </Modal>
    )
}


PaymentSuccess.propTypes = {
    message: PropTypes.string
};

export default PaymentSuccess;
